import { useGetAllChallenges, useGetMyLibraryChallenges } from '_api';
import { useMemo } from 'react';

const useChallenges = ({
  page = 0,
  size = 1000,
}: { page?: number; size?: number } = {}) => {
  const { data: allChallenges, isFetching: isLoading } = useGetAllChallenges({
    page,
    size,
  });

  const { data: sharedChallenges } = useGetMyLibraryChallenges({
    page,
    size,
  });

  const challengeOptions = useMemo(
    () =>
      allChallenges
        ? allChallenges.map((challenge) => ({
            name: challenge.id.toString(),
            description: challenge.title,
          }))
        : [],
    [allChallenges],
  );

  return { allChallenges, challengeOptions, sharedChallenges, isLoading };
};

export default useChallenges;
